(function() {
  angular
    .module('cfn')
    .factory('bookingMaskDataResolver', bookingMaskDataResolver);

  bookingMaskDataResolver.$inject = ['bookingActivitiesService'];

  function bookingMaskDataResolver(bookingActivitiesService) {
    return function() {
      return bookingActivitiesService.init();
    };
  }
})();
